import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class RequirementPricingReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            requirementId: props.RequirementId,
            controllerName: 'solution/requirement/pricing',
            data: null,
            loading: true,
            configName: 'solution_requirementpricing_reportt_grid',
            moduleName: 'برآوردهای مالی'
        };
        this.state.filters = {
            requirementId: this.state.requirementId
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "workFlowName", caption: "گردش کار", show: true },   
                { field: "workFlowStepName", caption: "گام", show: true },                
                { field: "userName", caption: "مسئول برآورد", show: true },
                { field: "date", caption: "تاریخ", show: true },
                { field: "price", caption: "مبلغ", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'workFlowName' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 2 });
            if (f.field == 'workFlowStepName' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 2 });
            if (f.field == 'userName' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'price' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.price) } });
        });
        return t;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">برآوردهای مالی</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(true, { add: false, print: true, pdf: true, excell: true, remove: false, config:false, otherFilters: null })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}